export const TEMPLATE_FIELD_TYPES = new Set(["text", "long_text", "number", "currency", "percentage", "date", "dropdown", "multi_select", "radio", "checkbox", "address", "contact", "file", "table", "repeating_group", "signature", "calculated"]);

export function normalizeTemplateSections(sections = []) {
  const used = new Set();
  const stableKey = (value, fallback) => {
    let key = String(value || fallback || "field").trim().replace(/[^a-zA-Z0-9_.-]+/g, "_").replace(/^[^a-zA-Z]+/, "").slice(0, 120) || "field";
    const base = key; let suffix = 2;
    while (used.has(key)) key = `${base.slice(0, 116)}_${suffix++}`;
    used.add(key); return key;
  };
  return (Array.isArray(sections) ? sections : []).map((section, sectionIndex) => ({
    title: String(section?.title || `Section ${sectionIndex + 1}`).trim().slice(0, 240),
    fields: (Array.isArray(section?.fields) ? section.fields : []).map((field, fieldIndex) => ({
      key: stableKey(field?.key, field?.label || `field_${fieldIndex + 1}`),
      label: String(field?.label || field?.key || `Field ${fieldIndex + 1}`).trim().slice(0, 240),
      type: TEMPLATE_FIELD_TYPES.has(field?.type) ? field.type : "text",
      required: field?.required === true,
      helpText: String(field?.helpText || "").slice(0, 1000),
      options: Array.isArray(field?.options) ? field.options.slice(0, 100).map((option) => String(option).slice(0, 240)) : [],
    })),
  })).filter((section) => section.fields.length);
}

export function flattenTemplateFolders(folders = []) {
  const byParent = new Map();
  folders.forEach((folder) => {
    const parent = folder.parentId || null;
    byParent.set(parent, [...(byParent.get(parent) || []), folder]);
  });
  const rows = [];
  const visit = (parentId, depth, seen) => {
    (byParent.get(parentId) || []).sort((a, b) => String(a.name).localeCompare(String(b.name))).forEach((folder) => {
      if (seen.has(folder.id)) return;
      rows.push({ ...folder, depth });
      visit(folder.id, depth + 1, new Set([...seen, folder.id]));
    });
  };
  visit(null, 0, new Set());
  return rows;
}
